// Helper functions for downloading data
import { API_BASE } from "@/lib/api";

export async function downloadCsv(path, filename) {
  const token = localStorage.getItem("access_token");
  const res = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error("Export failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}

export function downloadAsPdf(elementId, filename = "document.pdf") {
  // Lightweight print-to-PDF: open print dialog scoped to a fragment.
  const node = document.getElementById(elementId);
  if (!node) return window.print();
  const w = window.open("", "_blank", "noopener,noreferrer,width=900,height=700");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>${filename}</title>
    <style>body{font-family:system-ui,sans-serif;padding:24px;color:#111}
    table{width:100%;border-collapse:collapse;font-size:12px}
    th,td{padding:6px 8px;border-bottom:1px solid #ddd;text-align:left}
    h1{font-size:20px;margin:0 0 12px}</style></head><body>${node.innerHTML}</body></html>`);
  w.document.close();
  setTimeout(() => { w.focus(); w.print(); }, 250);
}
